module.exports = __webpack_public_path__ + "static/comingsoonvesthwdisc-ebfa61cf7b13169c3874ab0dd3a3d689.jpeg";